import { Layout, theme, Typography } from "antd";
import DepartmentsTable from "../components/departments/DepartmentsTable";
import AddDepartment from "../components/departments/AddDepartment";

const { Content } = Layout;

const Departments = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            YENİ ŞÖBƏ
          </Typography.Title>
          <AddDepartment />
          <Typography.Title level={5} className="titles-start">
            ŞÖBƏLƏR
          </Typography.Title>
          <DepartmentsTable />
        </div>
      </Content>
    </Layout>
  );
};

export default Departments;
